import codes from './codes';

function augmentError(error, data) {
  error.data = {
    ...error.data,
    ...data,
  };
}

function formatForLog(error) {
  return {
    error: {
      code: error.code,
      stack: error.stack,
      message: error.message,
      data: error.data,
    },
  };
}

export { augmentError, codes, formatForLog };
